<section>
    <div class="spacer {{spacerContainer}}" [ngClass]="{ 'divider-block': pageData.showDivider }" [ngStyle]="backgroundColorStyles">
        <div class="divider" *ngIf="pageData.showDivider" [ngStyle]="{ backgroundColor: pageData.dividerColor }"></div>
    </div>
</section>
